import { Grid } from "@mui/material";
import { withStyles, WithStyles } from "@mui/styles";
import style from "assets/jss/public-styles";
import HeaderLang from "layouts/Components/HeaderLang";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router-dom";
import Session from "services/Session";

////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IAppProps {
    component: any;
    fullView?: boolean;
}

type Props = IAppProps & RouteComponentProps<any> & WithStyles<typeof style> & WithTranslation;

////////////////////////////////////////////////////////////////////////////////////////////////////////

class PublicPage extends React.PureComponent<Props> {
    private mainPanel: HTMLElement;

    constructor(props: Props) {
        super(props);
        if (props.i18n.language != Session.uiCulture) props.i18n.changeLanguage(Session.uiCulture);
    }

    //
    public componentDidUpdate(e: Props) {
        if (e.history.location.pathname !== e.location.pathname) {
            this.mainPanel.scrollTop = 0;
        }
    }

    //
    public render() {
        const { classes, component: Component, fullView, ...rest } = this.props;

        return (
            <div className={classes.page} ref={(ref) => { this.mainPanel = ref; }}>
                <div className={classes.pageHeader}>
                    <div className={classes.container}>

                        <Grid container direction="column" style={{ height: "100%", padding: 16 }}>

                            <Grid item xs>
                                <Grid container justifyContent="center" alignItems="center" style={{ height: "100%" }}>
                                    <Grid item xs sm={10} md={8} lg={6}>
                                        <Component {...rest} />
                                    </Grid>
                                </Grid>
                            </Grid>

                            {
                                fullView &&
                                <Grid item>
                                    <Grid container alignItems="flex-end" direction="column">
                                        <Grid item>
                                            <HeaderLang />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            }
                        </Grid>


                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(withStyles(style)(PublicPage));
